// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckABModal__wrapper--2Pgvp","icon":"CheckABModal__icon--2PfD1","subTitle":"CheckABModal__subTitle--InT6x","footer":"CheckABModal__footer--1oxph"};